import { Info } from "lucide-react";
import { Reveal } from "../../lib/motion";
import { DISCLOSURE } from "../../data";

export const Disclosure = () => {
  return (
    <section className="py-24 md:py-28 bg-warm-light/50">
      <div className="max-w-4xl mx-auto px-6 md:px-10">
        <Reveal>
          <div
            data-testid="disclosure-box"
            className="bg-white border border-warm-border border-l-4 border-l-water rounded-r-2xl rounded-l-lg p-8 md:p-10 shadow-sm"
          >
            <div className="flex items-center gap-3 mb-6">
              <div className="w-10 h-10 rounded-full bg-water/10 flex items-center justify-center">
                <Info size={20} className="text-water" />
              </div>
              <h3 className="font-serif text-2xl md:text-3xl text-navy">Important Disclosure</h3>
            </div>
            <div className="space-y-4">
              {DISCLOSURE.map((p, i) => (
                <p key={i} className="text-warm leading-relaxed">{p}</p>
              ))}
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
